import { environment as env } from "src/environments/environment"

export class CoverImagesHelper {
  static getCoverImageUrl(coverImageName: string) {
    return `${env.images_url_base}${coverImageName}`;
  }
}
